import {Component, ContentChild, Input, TemplateRef} from '@angular/core';
import {NgbCarouselConfig} from "@ng-bootstrap/ng-bootstrap";

@Component({
    selector: 'carousel',
    template: `<ngb-carousel [interval]="interval">
    <ng-template ngbSlide *ngFor="let slideData of data">
        <ng-content *ngTemplateOutlet="slideTemplate, context: { $implicit: slideData }"></ng-content>
    </ng-template>
</ngb-carousel>

`,
    styles: [`:host{height:inherit;width:inherit}:host /deep/ ngb-carousel{width:inherit;height:inherit}:host /deep/ ngb-carousel li:focus,:host /deep/ ngb-carousel:focus{outline:0!important}:host /deep/ .carousel-inner{overflow:visible}:host /deep/ .carousel-inner .carousel-caption{left:7%;right:7%;text-align:left}:host /deep/ .carousel-item{display:-webkit-box!important;display:-ms-flexbox!important;display:flex!important;opacity:0;visibility:hidden;-webkit-transition:opacity 1.2s ease-in-out,visibility 1.2s;transition:opacity 1.2s ease-in-out,visibility 1.2s;z-index:-1;position:absolute}:host /deep/ .carousel-item.active{opacity:1;overflow:hidden;visibility:visible;z-index:10}:host /deep/ .carousel-control-next,:host /deep/ .carousel-control-prev{width:7%;z-index:20}:host /deep/ .carousel-indicators{z-index:20}`]
})
export class CarouselComponent {

    @Input() data: any[];

    @Input() interval: number = 5000;

    @ContentChild('carousel') slideTemplate: TemplateRef<any>;

    // ########################################

    private config: NgbCarouselConfig = null;

    // ########################################

    constructor(config: NgbCarouselConfig) {
        this.config = config;
    }

    // ########################################

}
